import { render, staticRenderFns } from "./CorteIgnicion.vue?vue&type=template&id=242b0e92&"
import script from "./CorteIgnicion.vue?vue&type=script&lang=ts&"
export * from "./CorteIgnicion.vue?vue&type=script&lang=ts&"
import style0 from "./CorteIgnicion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports